import React from "react";
import { cn } from "~/lib/utils";

interface LoaderProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-4 h-4 border-2",
  md: "w-8 h-8 border-2", 
  lg: "w-12 h-12 border-4"
};

export function Loader({ size = "md", className }: LoaderProps) {
  return (
    <div
      className={cn(
        "border-primary border-t-transparent rounded-full animate-spin",
        sizeClasses[size],
        className
      )}
    />
  );
}
